
export class GetCompanyUserByEmployeeRoleInput {
    companyIds: string[];
    employeeRoleId: string;
    userId: string;
}